var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"custom-render"}},[(_vm.loadComplete)?[_c('page-render',{ref:"vFormRef"})]:[_c('div',{staticClass:"empty"},[_vm._v("正在初始化页面")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }